import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import SchoolOSPage from "./pages/SchoolOS";
import EventOSPage from "./pages/EventOS";
import EducationalTourismPage from "./pages/EducationalTourism";
import CorporateTravelPage from "./pages/CorporateTravel";
import DestinationManagementPage from "./pages/DestinationManagement";
import PartnersPage from "./pages/Partners";
import InsightsPage from "./pages/Insights";
import InsightDetailPage from "./pages/InsightDetail";
import FAQPage from "./pages/FAQ";
import ContactPage from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import DiplomexaPage from "./pages/Diplomexa";

function PublicChrome({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  if (isAdmin) {
    return <>{children}</>;
  }
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PublicChrome>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/school-os" element={<SchoolOSPage />} />
              <Route path="/event-os" element={<EventOSPage />} />
              <Route
                path="/educational-tourism"
                element={<EducationalTourismPage />}
              />
              <Route path="/corporate-travel" element={<CorporateTravelPage />} />
              <Route
                path="/destination-management"
                element={<DestinationManagementPage />}
              />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/insights/:slug" element={<InsightDetailPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/diplomexa" element={<DiplomexaPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </PublicChrome>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
